import $ from 'jquery';

import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

class TvsCarousel extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            slidesPerView: 1,
            modules: [Pagination, Navigation, Autoplay],
            pagination: true,
            pagination: {
                el: '.hero-pagination',
                clickable: true,
            },
            autoplay: {
                delay: slideDelay,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            },
            on: {
                init: function () {
                    var maxHeight = 0;

                    function getDivHeight(selector) {
                        const elements = document.querySelectorAll(selector);
                        let maxHeight = 0;
                        elements.forEach(element => {
                            maxHeight = Math.max(maxHeight, element.offsetHeight);
                        });
                        return maxHeight;
                    }

                    function setDivHeight(selector) {
                        const elements = document.querySelectorAll(selector);
                        const maxHeight = getDivHeight(selector);
                        elements.forEach(element => {
                            element.style.height = `${maxHeight}px`;
                        });
                    }

                    setDivHeight('.hero-carousel__content');
                },
            },
        })

        swiper.on('slideChange', function (e) {
            $('.swiper-pagination-bullet-active').prevAll().addClass('prev')
            setTimeout(() => {
                $('.swiper-pagination-bullet').removeClass('prev')
            }, 5300)
        })
    }
}

customElements.define('hero-carousel', TvsCarousel)
